var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    ref: "input",
    class: ["number-input", { "bordure-rouge": _vm.invalideParcequeVide }],
    style: _vm.disabled === true ? "border-color:transparent!important;" : "",
    attrs: {
      id: _vm.id,
      type: "text",
      autocomplete: "off",
      required: _vm.invalideSiVide,
      disabled: _vm.disabled === true
    },
    domProps: { value: _vm.domValue },
    on: {
      click: function($event) {
        $event.stopPropagation()
        return _vm.handleClick.apply(null, arguments)
      },
      input: _vm.handleInput,
      focus: _vm.handleFocus,
      blur: _vm.handleBlur,
      keyup: [
        _vm.handleKey,
        function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.handleSave.apply(null, arguments)
        }
      ]
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }